import React, { useState } from 'react';

import { createStyles, Group, Paper, Tabs, Title } from '@mantine/core';
import ClassTypeMultiSelectAutoComplete, {
  IEventTypeMultiSelectAutoComplete,
} from 'components/form-fields/auto-complete-fields/EventTypeMultiSelectAutoComplete';
import KiloTabs from 'components/KiloTabs/KiloTabs';

import { FilterTerms, ProgrammingTab } from './types';

const useStyles = createStyles(theme => ({
  header: {
    padding: theme.spacing.lg,
    paddingBottom: 0,
    background: theme.colors.gray[0],
    borderRadius: 0,
    display: 'grid',
    gridTemplateColumns: 'auto max-content',
    gridTemplateRows: 'auto',
    gridTemplateAreas: `
      "title search"
      "tabs tabs"
    `,
    alignItems: 'center',
    gap: theme.spacing.sm,
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: `
        'title'
        'search'
        'tabs'
      `,
    },
  },
  title: {
    gridArea: 'title',
  },
  search: {
    gridArea: 'search',
  },
  tabs: {
    gridArea: 'tabs',
  },
}));

interface ProgramsHeaderProps {
  initialSearchFiltersValue: FilterTerms;
  setSearchFilters: React.Dispatch<React.SetStateAction<FilterTerms>>;
  activeTab: ProgrammingTab;
  setActiveTab: (tab: ProgrammingTab) => void;
}

const ProgramsPageHeader = ({
  setSearchFilters,
  activeTab,
  setActiveTab,
}: ProgramsHeaderProps): JSX.Element => {
  const { classes } = useStyles();

  const [kiloClassTypes, setKiloClassTypes] = useState<IEventTypeMultiSelectAutoComplete[]>([]);

  const handleKiloClassTypeChange = (values: IEventTypeMultiSelectAutoComplete[]): void => {
    setKiloClassTypes(values);
    setSearchFilters(prev => ({ ...prev, kiloClassTypes: values.map(v => v.eventTypeId) }));
  };

  return (
    <Paper className={classes.header}>
      <Group spacing='xs' align='center' pr='xl' className={classes.title}>
        <Title order={1} size='h1'>
          Programming
        </Title>
      </Group>
      {activeTab === 'classes' && (
        <ClassTypeMultiSelectAutoComplete
          handleChange={handleKiloClassTypeChange}
          values={kiloClassTypes}
          className={classes.search}
          data-cy='programmingTableContainer'
        />
      )}
      <KiloTabs
        className={classes.tabs}
        styles={theme => ({
          tab: {
            '&&, &&:hover, &&[data-active]': {
              fontSize: theme.fontSizes.md,
              backgroundColor: 'transparent',
            },
          },
        })}
        activeTab={activeTab}
        setActiveTab={value => setActiveTab(value as ProgrammingTab)}
      >
        <>
          <Tabs.Tab value='classes'>Classes</Tabs.Tab>
          <Tabs.Tab value='athletes'>Athletes</Tabs.Tab>
        </>
      </KiloTabs>
    </Paper>
  );
};

export default ProgramsPageHeader;
